import { Error } from "~/components/site/error";

export default function Fallback(): JSX.Element {
  return <Error statusCode={404} themed />;
}
